// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*4th step date range title*/

h4.inst-title.insttime-title {
    margin-top: 0px;
    font-size: initial;
}


button#load-data-table {
    padding: 2px;
    float: right;
}


/*back-next section at the steps*/
.next-back-btns-wrap {
    margin: 10px 0px 20px 0px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(128, 128, 128, 0.61);
}

.step-wrap-cst {
    cursor: default;
}


.not-set {
    color: #c55;
    font-style: italic;
}


.dashboard-chart {
    width: auto;
    margin-bottom: 20px;
    display: block;
}

/*scroll bar*/

::-webkit-scrollbar {
    background: #f5f5f5;
    height: 8px;
    width: 13px;
}

::-webkit-scrollbar-thumb {
    background: #333;
    border-radius: 4px;
}


/*dashboard decoration*/
tbody > tr.show-sensors.active-device > td > a {
    color: white;
}

tbody > tr.show-sensors.active-device {
    background-color: #333;
    cursor: pointer;
    color: white;
}

tbody > tr.show-sensors.active-device:hover {
    background-color: #333;
}

tr.show-sensors.not-clickable {
    cursor: auto;
}

tr.show-sensors {
    text-align: center;

}

.table > tbody > tr > td {
    padding: 2px 8px 2px 8px;
}

tbody > tr.show-sensors.no-sensors,
tbody > tr.show-sensors.no-sensors:hover {
    cursor: default;
    tab-index: -1;
    color: grey;
    background-color: #DDD;

}

tbody > tr.show-sensors.no-sensors,
tbody > tr.show-sensors.no-sensors:hover {
    cursor: default;
    color: grey !important;
    background-color: #DDD !important;

}


.modal-header {
    background: #333;
    color: white;
}


.nav-pills > li.active > a,
.nav-pills > li.active > a,
.nav-pills > li.active > a:hover,
.nav-pills > li.active > a:focus {
    background: rgba(255, 255, 255, 0);
    border-top: 4px solid #f0ad4e;
    padding-top: 5px;
    border-radius: 0;
}

.nav-pills > li.active > a:hover,
.nav-pills > li > a:hover {
    background: rgba(255, 255, 255, 0);
}


h1 {
    color: #333;
}

/*Secondary navigation*/

#cst-secondary-nav {
    background: #f5f5f5;
}

/* Pagination */
.pagination {
    margin-bottom: 0px;
    margin-top: 0px;
}


.dashboard-index {
    background-color: #ededed;
}

.dashboard-index .step-icon {
    background-color: #ededed;
    font-size: 28px;
    position: relative;
    top: 5px;
}

.dashboard-index .wrapper {
    display: table;
    width: 100%;
    table-layout: fixed;
}

.dashboard-index .content-wrapper {
    display: table-row;
    width: auto;
}

.dashboard-index .content-wrapper .col-table {
    display: table-cell;
    vertical-align: top;
}

.dashboard-index .content-wrapper .col-table {
    padding: 15px 20px;
    background-color: #fff;
    border: 1px solid #e3e3e3;
}

.dashboard-index .btn-wizard {
    border-radius: 0;
}

@media (max-width: 992px) {


    .dashboard-index .content-wrapper {
        display: block;
    }

    .dashboard-index .content-wrapper .col-table {
        display: block;
    }

}


thead > tr:first-child  {
    background: #333;
    color: white;
}

thead > tr:first-child a {
    color: white;
}

thead > tr:nth-child(2)  {
    background: #333;
    color: white;
}


.passive-st {
    background-color: #f0ad4e;
    color: #fff;
}

.active-st{
    background-color: #5cb85c;
    color:#fff;
}


.inst-title {
    color:#337ab7;
}


#load-data-table {
    float:right;
}


.modal-body p.alert.alert-success {
    background-color: #dff0d8;
    text-align: center;
}


.steps-icons {
    color: #f0ad4e;
    margin: 5px 10px 5px 8px;
}


.not-set {
    color: #c55;
    font-style: italic;
}

.active {
    display: block;
}

.new-sensor-name.error {
    border: 1px solid red;
}

/* Global style for links */
a {
  color: #6da92d;
}
a:hover {
  color: #87d137;
}`, "",{"version":3,"sources":["webpack://./src/site.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;IACI,eAAe;IACf,kBAAkB;AACtB;;;AAGA;IACI,YAAY;IACZ,YAAY;AAChB;;;AAGA,iCAAiC;AACjC;IACI,yBAAyB;IACzB,oBAAoB;IACpB,kDAAkD;AACtD;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,WAAW;IACX,kBAAkB;AACtB;;;AAGA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;;AAEA,aAAa;;AAEb;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA,uBAAuB;AACvB;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,eAAe;IACf,aAAa;IACb,WAAW;IACX,sBAAsB;;AAE1B;;AAEA;;IAEI,eAAe;IACf,sBAAsB;IACtB,iCAAiC;;AAErC;;;AAGA;IACI,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;;;;IAII,kCAAkC;IAClC,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,kCAAkC;AACtC;;;AAGA;IACI,WAAW;AACf;;AAEA,uBAAuB;;AAEvB;IACI,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;IAGI;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;AAEJ;;;AAGA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;;AAGA;IACI,aAAa;AACjB;;;AAGA;IACI,WAAW;AACf;;;AAGA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;;AAGA;IACI,cAAc;IACd,wBAAwB;AAC5B;;;AAGA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB","sourcesContent":["/*4th step date range title*/\n\nh4.inst-title.insttime-title {\n    margin-top: 0px;\n    font-size: initial;\n}\n\n\nbutton#load-data-table {\n    padding: 2px;\n    float: right;\n}\n\n\n/*back-next section at the steps*/\n.next-back-btns-wrap {\n    margin: 10px 0px 20px 0px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid rgba(128, 128, 128, 0.61);\n}\n\n.step-wrap-cst {\n    cursor: default;\n}\n\n\n.not-set {\n    color: #c55;\n    font-style: italic;\n}\n\n\n.dashboard-chart {\n    width: auto;\n    margin-bottom: 20px;\n    display: block;\n}\n\n/*scroll bar*/\n\n::-webkit-scrollbar {\n    background: #f5f5f5;\n    height: 8px;\n    width: 13px;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #333;\n    border-radius: 4px;\n}\n\n\n/*dashboard decoration*/\ntbody > tr.show-sensors.active-device > td > a {\n    color: white;\n}\n\ntbody > tr.show-sensors.active-device {\n    background-color: #333;\n    cursor: pointer;\n    color: white;\n}\n\ntbody > tr.show-sensors.active-device:hover {\n    background-color: #333;\n}\n\ntr.show-sensors.not-clickable {\n    cursor: auto;\n}\n\ntr.show-sensors {\n    text-align: center;\n\n}\n\n.table > tbody > tr > td {\n    padding: 2px 8px 2px 8px;\n}\n\ntbody > tr.show-sensors.no-sensors,\ntbody > tr.show-sensors.no-sensors:hover {\n    cursor: default;\n    tab-index: -1;\n    color: grey;\n    background-color: #DDD;\n\n}\n\ntbody > tr.show-sensors.no-sensors,\ntbody > tr.show-sensors.no-sensors:hover {\n    cursor: default;\n    color: grey !important;\n    background-color: #DDD !important;\n\n}\n\n\n.modal-header {\n    background: #333;\n    color: white;\n}\n\n\n.nav-pills > li.active > a,\n.nav-pills > li.active > a,\n.nav-pills > li.active > a:hover,\n.nav-pills > li.active > a:focus {\n    background: rgba(255, 255, 255, 0);\n    border-top: 4px solid #f0ad4e;\n    padding-top: 5px;\n    border-radius: 0;\n}\n\n.nav-pills > li.active > a:hover,\n.nav-pills > li > a:hover {\n    background: rgba(255, 255, 255, 0);\n}\n\n\nh1 {\n    color: #333;\n}\n\n/*Secondary navigation*/\n\n#cst-secondary-nav {\n    background: #f5f5f5;\n}\n\n/* Pagination */\n.pagination {\n    margin-bottom: 0px;\n    margin-top: 0px;\n}\n\n\n.dashboard-index {\n    background-color: #ededed;\n}\n\n.dashboard-index .step-icon {\n    background-color: #ededed;\n    font-size: 28px;\n    position: relative;\n    top: 5px;\n}\n\n.dashboard-index .wrapper {\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n}\n\n.dashboard-index .content-wrapper {\n    display: table-row;\n    width: auto;\n}\n\n.dashboard-index .content-wrapper .col-table {\n    display: table-cell;\n    vertical-align: top;\n}\n\n.dashboard-index .content-wrapper .col-table {\n    padding: 15px 20px;\n    background-color: #fff;\n    border: 1px solid #e3e3e3;\n}\n\n.dashboard-index .btn-wizard {\n    border-radius: 0;\n}\n\n@media (max-width: 992px) {\n\n\n    .dashboard-index .content-wrapper {\n        display: block;\n    }\n\n    .dashboard-index .content-wrapper .col-table {\n        display: block;\n    }\n\n}\n\n\nthead > tr:first-child  {\n    background: #333;\n    color: white;\n}\n\nthead > tr:first-child a {\n    color: white;\n}\n\nthead > tr:nth-child(2)  {\n    background: #333;\n    color: white;\n}\n\n\n.passive-st {\n    background-color: #f0ad4e;\n    color: #fff;\n}\n\n.active-st{\n    background-color: #5cb85c;\n    color:#fff;\n}\n\n\n.inst-title {\n    color:#337ab7;\n}\n\n\n#load-data-table {\n    float:right;\n}\n\n\n.modal-body p.alert.alert-success {\n    background-color: #dff0d8;\n    text-align: center;\n}\n\n\n.steps-icons {\n    color: #f0ad4e;\n    margin: 5px 10px 5px 8px;\n}\n\n\n.not-set {\n    color: #c55;\n    font-style: italic;\n}\n\n.active {\n    display: block;\n}\n\n.new-sensor-name.error {\n    border: 1px solid red;\n}\n\n/* Global style for links */\na {\n  color: #6da92d;\n}\na:hover {\n  color: #87d137;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
